import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getTiposSexos } from './tipos_sexos_service';
import GridBase from '../../../components/grid_base';
import StatusPesquisar from '../../../components/status_pesquisar';
var LIMITE_BUSCA = 100;
var COLUNAS = [
    {
        field: 'nome',
        headerName: 'Nome',
        width: 500,
    },
    {
        field: 'situacao',
        headerName: 'Situação',
        width: 150,
    },
];
export var TiposSexosListar = function () {
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_SEXOS, paginaPermissao: FUNCIONALIDADES.TIPOS_SEXOS, rota: ROUTES.TIPOS_SEXOS, columns: COLUNAS, filtrosIniciais: {
            situacao: '-1',
        }, fetchData: function (textoBusca, filtros, paginationModel) {
            var textoTratado = textoBusca ? textoBusca.slice(0, LIMITE_BUSCA) : null;
            return getTiposSexos(textoTratado === '' ? null : textoTratado, filtros.situacao === '-1' ? null : filtros.situacao, paginationModel);
        }, renderFiltros: function (filtros, atualizarFiltros) { return (_jsx(StatusPesquisar, { StatusPesquisa: filtros.situacao, filtrarGrid: function (_, novaSituacao) {
                atualizarFiltros({ situacao: novaSituacao });
            } })); } }));
};
export default TiposSexosListar;
